/**
 * Sitemap 语言子集（与 `languages.config.mjs` 的 `sitemapLanguages` 保持一致）。
 * 勿与 `utils/i18n` 的 `locales` 混用——后者为 App 运行时全量语言。
 */
export const SITEMAP_LANGUAGES = ["en", "zh-tw"] as const;

/** hreflang / alternateRefs：含 x-default（""）与 en、zh-tw */
export const SITEMAP_ALTERNATE_LOCALES = ["", ...SITEMAP_LANGUAGES] as const;

/** `[locale]/(sitemaps)/*` 路由 param：允许 ""（默认 en 路径）或显式 locale */
export function isValidSitemapLocale(locale: string): boolean {
  return (SITEMAP_ALTERNATE_LOCALES as readonly string[]).includes(locale);
}

/** alternateRefs 的 hreflang：x-default + BCP47 简码 */
export function sitemapHreflang(locale: string): string {
  return locale === "" ? "x-default" : locale;
}
